module.exports = __webpack_public_path__ + "static/img/example-6.bd785f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/example-6.png
// module id = JqNI
// module chunks = 2